<template>
  <jz-container class="assignments-card" v-if="historicalTotal > 0">
    <jz-container class="header">
      <jz-container class="section-header">
        {{ "assignments.title" | __ }}
      </jz-container>
      <jz-container>
        <router-link :to="{ name: assignmentExploreRouteName }" class="assignment-explore-link">
          {{ "assignments.see-all" | __ }}
        </router-link>
      </jz-container>
    </jz-container>

    <jz-container v-if="activeAssignments.length <= 0" class="empty-assignments-notice" flex fill>
      {{ "assignments.no-assignments" | __ }}
    </jz-container>

    <jz-container v-else class="assignment-cards">
      <assignment-card
        v-for="(assignment, index) in activeAssignments"
        :key="index"
        :assignment="assignment"
      />
    </jz-container>
  </jz-container>
</template>

<script>
import { mapState } from "vuex";
import { ROUTES, VUEX_ASSIGNMENT_ACTION_NAMES, VUEX_ASSIGNMENT_NAMESPACE } from "@tt-app/constants";
import AssignmentCard from "@tt-app/components/assignment/AssignmentCard";
import bookIcon from "@joyz/app-core/assets/icons/default/Book.svg";

const {
  ASSIGNMENT: { EXPLORE }
} = ROUTES;

const { MINE } = VUEX_ASSIGNMENT_ACTION_NAMES;

export default {
  name: "AssignmentsCard",
  components: { AssignmentCard },
  computed: {
    ...mapState({
      activeAssignments: state => state.assignment.active,
      historicalTotal: state => state.assignment.historicalTotal
    })
  },
  created() {
    this.bookIcon = bookIcon;
    this.assignmentExploreRouteName = EXPLORE.NAME;
    this.assignmentDetailsRouteName = ROUTES.ASSIGNMENT.DETAILS.NAME;
    this.fetchInitialData();
  },
  methods: {
    async fetchInitialData() {
      await this.$store.dispatch(`${VUEX_ASSIGNMENT_NAMESPACE}/${MINE}`);
    }
  }
};
</script>

<style lang="scss">
.assignments-card {
  .header {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin-bottom: $gutter / 2;
    .assignment-explore-link {
      color: var(--color-dark);
      font-size: $font-size-sm;
      font-weight: bold;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .empty-assignments-notice {
    align-items: center;
    justify-content: center;
    margin: ($gutter * 2) $gutter;

    @include is-text-description($font-size-sm);
  }

  .assignment-cards {
    display: grid;
    gap: $gutter;
    grid-template-columns: repeat(1, auto);
    grid-template-rows: 134px;
    overflow-y: auto;
    margin: -10px -8px;
    padding: 10px;
  }
}

@include responsive(tablet) {
  .assignments-card {
    .assignment-cards {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@include responsive(desktop) {
  .assignments-card {
    .assignment-cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
